import React, { Fragment } from 'react';
import { isScalar } from './utils';

/**
 * React.render() must return a React element or null, so this function
 * can be used to return any other content like string, number, or array,
 * and it will wrap it in a <span> if needed or return it if already
 * can be rendered.
 *
 * @param expression Content to render
 * @return {*} Content, wrapped if necessary.
 */
export function wrapExpressionForRender(expression) {
  if (expression === null || expression === undefined) {
    return null;
  }
  if (Array.isArray(expression)) {
    return <Fragment>{expression}</Fragment>;
  }
  return isScalar(expression) ? <Fragment>{expression}</Fragment> : expression;
}
